const classList: string[] = [];
const callbacks: Function[] = [];

let backdropLayer: HTMLDivElement;

export function initBackdrop() {
	backdropLayer = document.createElement('div');
	backdropLayer.classList.add('backdrop');
	backdropLayer.addEventListener('click', onBackdropLayerClick);
	document.body.appendChild(backdropLayer);
}

export function addClassToList(className: string) {
	classList.push(className);
}

export function addCallback(func: Function) {
	callbacks.push(func);
}

export function toggle(className: string) {
	if (document.body.classList.contains(className)) {
		removeClass(className);
	} else {
		addClass(className);
	}
}

export function addClass(className: string) {
	document.body.classList.add(className);
	show();
}

export function removeClass(className: string) {
	document.body.classList.remove(className);
	hide();
}

export function show() {
	backdropLayer.classList.add('is-active');
}

export function hide() {
	backdropLayer.classList.remove('is-active');
}

function onBackdropLayerClick() {
	for (let i = 0, classListCount = classList.length; i < classListCount; i++) {
		if (document.body.classList.contains(classList[i])) {
			removeClass(classList[i]);
		}
	}

	if (callbacks && callbacks.length) {
		Array.prototype.forEach.call(callbacks, (callback: Function) => {
			if (typeof callback === 'function') {
				callback();
			}
		});
	}
}
